
import { Component, Prop } from "vue-property-decorator";
import { HcPageModel, HcTable, ITableData, TableData, CaptionModel } from "@dev/hc-components";
import Mode from "./ApprovalResultModeEnum";
import RouteName from "@/app/router/NameEnum";
import { MainLayout } from "@/app/index";

@Component({
    components: { MainLayout }
})
export default class ApprovalResult extends HcPageModel {
    @Prop({ required: false }) public mode!: string;

    protected pageName: string = "approval-result";
    public name: string = "approval-result";

    private get tableData(): ITableData {
        let data: any[][] = new Array();
        let queryParams = this.$route.query;
        Object.keys(queryParams).forEach(e => data.push([e, queryParams[e]]));

        return new TableData(
            new CaptionModel("Standard table", false),
            [
                {
                    name: this.$localize("pg-approval-result-name")
                },
                {
                    name: this.$localize("pg-approval-result-value")
                }
            ],
            data
        );
    }

    private get resultText(): string {
        return this.$localize(
            this.mode === Mode.ACCEPTED ? "pg-approval-result-accepted" : "pg-approval-result-rejected"
        );
    }
}
